import React from 'react';
import 'styles/loaderStyles.css';


const Loader = () => {
  return (
    <div className="loader">
      <div className="loader_spinner" />
    </div>
  );
};

export default Loader;
